import { z } from 'zod';
import { AreaValueSchema } from './measurements';
import { MonetaryValueSchema, SquareMetreMoneyPerAreaValueSchema } from './money';
const deviationSchema = (value) => {
    const shape = {
        base_value: value.nullish(),
        comparison_valuation: value.nullish(),
        deviation: value.nullish(),
        deviation_percentage: z.number().nullish(),
    };
    return z.object(shape);
};
const monetaryDeviationSchema = deviationSchema(MonetaryValueSchema);
const areaDeviationSchema = deviationSchema(AreaValueSchema);
const numberDeviationSchema = deviationSchema(z.number());
const moneyPerAreaDeviationSchema = deviationSchema(SquareMetreMoneyPerAreaValueSchema);
const MarketValuePerAreaDeviationShape = {
    market_value_per_gross_floor_area: moneyPerAreaDeviationSchema,
    market_value_per_land_area: moneyPerAreaDeviationSchema.optional(),
    market_value_per_rentable_area: moneyPerAreaDeviationSchema,
};
const MarketValuePerAreaDeviationSchema = z.object(MarketValuePerAreaDeviationShape);
const LeadingMarketValuePerAreaDeviationShape = {
    ...moneyPerAreaDeviationSchema.shape,
    perAreaLabel: z.string(),
};
const LeadingMarketValuePerAreaDeviationSchema = z.object(LeadingMarketValuePerAreaDeviationShape);
const YearPeriodDeviationShape = {
    ...numberDeviationSchema.shape,
    deviation_percentage: z.null(),
};
const YearPeriodDeviationSchema = z.object(YearPeriodDeviationShape);
const StructureDeviationShape = {
    title: z.string(),
    uuid: z.string(),
    life_span_deviation: YearPeriodDeviationSchema,
};
const StructureDeviationSchema = z.object(StructureDeviationShape);
const DeviationAnalysisBaseShape = {
    market_value: monetaryDeviationSchema,
    mortgage_lending_value: monetaryDeviationSchema.optional(),
    total_special_property_features: monetaryDeviationSchema,
    gross_capital_value: monetaryDeviationSchema,
    net_capital_value: monetaryDeviationSchema,
    ancillary_acquisition_costs: monetaryDeviationSchema,
    net_yield: numberDeviationSchema,
    gross_yield: numberDeviationSchema,
    gross_yield_multiplier: numberDeviationSchema,
    net_yield_multiplier: numberDeviationSchema,
    gross_rental_income: monetaryDeviationSchema,
    contractual_rental_income: monetaryDeviationSchema,
    transaction_costs: monetaryDeviationSchema,
    management_costs: monetaryDeviationSchema,
    rentable_area: areaDeviationSchema,
    gross_floor_area: areaDeviationSchema,
    net_rental_income: monetaryDeviationSchema,
    market_value_per_area: MarketValuePerAreaDeviationSchema,
    leading_market_value_per_area: LeadingMarketValuePerAreaDeviationSchema.optional(),
};
export const DeviationAnalysisBaseSchema = z.object(DeviationAnalysisBaseShape);
const ValuationDeviationAnalysisShape = {
    ...DeviationAnalysisBaseShape,
    land_value: monetaryDeviationSchema,
    income_market_value: monetaryDeviationSchema,
    cost_market_value: monetaryDeviationSchema,
    comparison_market_value: monetaryDeviationSchema,
    discount_rate: numberDeviationSchema,
    maintenance_cost: monetaryDeviationSchema,
    administrative_cost: monetaryDeviationSchema,
    operating_cost: monetaryDeviationSchema,
    loss_of_rent_risk_cost: monetaryDeviationSchema,
    net_income_construction: monetaryDeviationSchema,
    value_construction: monetaryDeviationSchema,
    gross_initial_yield: numberDeviationSchema,
    structures: StructureDeviationSchema.array(),
    base_valuation_selected_valuation_methods: z.array(z.string()),
};
export const ValuationDeviationAnalysisSchema = z.object(ValuationDeviationAnalysisShape);
export const ValueCheckDeviationAnalysisSchema = DeviationAnalysisBaseSchema;
export const DeviationAnalysisSchema = ValuationDeviationAnalysisSchema;
